import React from "react";
import { RouteComponentProps } from "react-router-dom";
import { Page } from "components/shared/Page/Page";
import { makeStyles } from "@material-ui/core/styles";
import { ResetPasswordForm } from "components/user/ResetPasswordForm/ResetPasswordForm";

const useStyles = makeStyles(() => ({
  resetPassword: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
  },
}));

interface Props {}

export const ResetPassword = (props: RouteComponentProps<Props>) => {
  const classes = useStyles();
  return (
    <Page animate className={classes.resetPassword}>
      <ResetPasswordForm />
    </Page>
  );
};
